import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { SketchPicker } from 'react-color'

import './ColorField.scss'
import Modal from '../../../../app/customModal/Modal'
import { useModalState } from '../../../../../utils/general'

const ColorField = props => {
  const { isOpen, closeModal, openModal } = useModalState()
  const [color, setColor] = useState(props.color)

  return (
    <div className="group">
      {props.showLabel !== false ? <label className="form-label">{props.name}</label> : null}
      <div className="color-holder" style={{ background: props.color, ...props.style }} onClick={openModal} />
      <Modal.Wrapper isOpen={isOpen} title="Select color" onCloseModal={closeModal} className="color-picker">
        <SketchPicker
          disableAlpha={true}
          color={color}
          presetColors={[
            '#EDFF8C',
            '#FFD77E',
            '#C2ECB5',
            '#FF706F',
            '#FFAD90',
            '#F39765',
            '#84CEF5',
            '#919191',
            '#C94CCF'
          ]}
          onChangeComplete={color => setColor(color)}
        />
        <Modal.Buttons>
          <button className="btn" onClick={saveColor}>
            Save
          </button>
        </Modal.Buttons>
      </Modal.Wrapper>
    </div>
  )

  function saveColor() {
    props.onColorChange(color)
    closeModal()
  }
}

ColorField.propTypes = {
  name: PropTypes.string.isRequired,
  showLabel: PropTypes.bool,
  color: PropTypes.string.isRequired,
  onColorChange: PropTypes.func.isRequired,
  style: PropTypes.object
}

export default ColorField
